import { render, staticRenderFns } from "./generalAdminInformation.vue?vue&type=template&id=f2346322"
import script from "./generalAdminInformation.vue?vue&type=script&lang=js"
export * from "./generalAdminInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports